export default __webpack_public_path__ + "static/media/grateful_for_my_body.fd43aded.jpg";